import * as React from "react";
import { Button, Grid, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import { API } from "aws-amplify";

interface IProps {
    data?: any
}

interface IState {
    dateWritten: string
    errorMessage: any
    prescriptionId: string
    response: any
}

class UpdateDateWrittenSection extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            dateWritten: '',
            errorMessage: '',
            prescriptionId: '',
            response: ''
        }

        this.handlePrescriptionIdChange = this.handlePrescriptionIdChange.bind(this);
        this.handleDateWrittenChange = this.handleDateWrittenChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return (
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <TextField
                        style={{width: 400}}
                        label="Prescription Id"
                        variant="outlined"
                        value={ this.state.prescriptionId }
                        onChange={ this.handlePrescriptionIdChange }
                    />
                </Grid>
                <Grid item xs>
                    <TextField
                        style={{width: 400}}
                        label="Date Written (yyyy-mm-dd)"
                        variant="outlined"
                        value={ this.state.dateWritten }
                        onChange={ this.handleDateWrittenChange }
                    />
                </Grid>
                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Update Date Written
                    </Button>
                </Grid>

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private handlePrescriptionIdChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ prescriptionId: event.target.value });
    }

    private handleDateWrittenChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ dateWritten: event.target.value });
    }

    private resetOutput() {
        this.setState({ errorMessage: '' });
        this.setState({ response: '' });
    }

    private handleSubmit() {
        this.resetOutput();
        if (!this.state.dateWritten.match("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$")) {
            alert('Please enter a valid date matching the format yyyy-mm-dd');
            return;
        }
        this.callUpdateDateWritten({
            body: {
                dateWritten: this.state.dateWritten,
                prescriptionId: this.state.prescriptionId
            },
            headers: {}
        });
    }

    private callUpdateDateWritten(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/update-date-written';

        console.log(config)
        API.post(apiName, path, config).then((updateDateWrittenResponse: any) => {
            console.log(updateDateWrittenResponse);
            this.setState({ response: updateDateWrittenResponse });
        }).catch((error) => {
            console.log(error);
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default UpdateDateWrittenSection;
